import { render, staticRenderFns } from "./ToutiaoCard.vue?vue&type=template&id=1a5a4d6c&scoped=true"
import script from "./ToutiaoCard.vue?vue&type=script&lang=ts"
export * from "./ToutiaoCard.vue?vue&type=script&lang=ts"
import style0 from "./ToutiaoCard.vue?vue&type=style&index=0&id=1a5a4d6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5a4d6c",
  null
  
)

export default component.exports